import React, { AllHTMLAttributes, FC, PropsWithChildren } from 'react';

import Modal from '../Modal';
import styles from './AddOnboardingModal.module.scss';

export interface ModalProps extends AllHTMLAttributes<HTMLDivElement> {
  active: boolean;
  onClose: () => void;
}

const AddOnboardingModal: FC<PropsWithChildren<ModalProps>> = ({ active, onClose, children }) => {
  return (
    <Modal className={styles.myModal} active={active} onClose={onClose}>
      <div className={styles.myModal__content}>{children}</div>
    </Modal>
  );
};

export default AddOnboardingModal;
